import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ServicePlans from "./ServicePlans";
import OtherServicePlans from "./OtherServicePlans";
import Balance from "./Balance";
import Transactions from "../common/Transactions";
import Advertisement from "../common/Advertisement";
import TabComponent from "../common/TabComponent";
import { useLanguage } from "../common/LanguageContext";
 import homePageService from "../services/HomePageService"; 
import "./main.css";

const Main = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const [activeTab, setActiveTab] = useState("tab1"); // ✅ Tracks selected tab
  const [activePage, setActivePage] = useState(1);
  const [otherPage, setOtherPage] = useState(1);
  const itemsPerPage = 6;
  const [servicePlans,setServicePlans ]=useState([]);
  const[otherServicePlans,setOtherServicePlans]=useState([]);
  // ✅ Static service plans for testing
  // ✅ Static service plans for testing
  /* const servicePlans = [
   {
      serviceId: "1",
      servicePK: "PK1",
      serviceName: "SMR Bots",
      serviceDescription:
        "Automated bots for smart resource management.It helps you see how many more days you need to work to reach your financial goal for the month and year.",
    },
    {
      serviceId: "2",
      servicePK: "PK2",
      serviceName: "PSF Bots",
      serviceDescription:
        "Personalized service bots with AI-driven responses.It helps you see how many more days you need to work to reach your financial goal for the month and year.",
    },
    {
      serviceId: "3",
      servicePK: "PK3",
      serviceName: "Finance Tracker 1",
      serviceDescription:
        "Track expenses and monitor financial growth.It helps you see how many more days you need to work to reach your financial goal for the month and year.",
    },
    {
      serviceId: "4",
      servicePK: "PK4",
      serviceName: "Finance Tracker 2",
      serviceDescription:
        "Track expenses and monitor financial growth.It helps you see how many more days you need to work to reach your financial goal for the month and the year.",
    },
    {
      serviceId: "5",
      servicePK: "PK5",
      serviceName: "Finance Tracker 3",
      serviceDescription:
        "Track expenses and monitor financial growth.It helps you see how many more days you need to work to reach your financial goal for the month and the year.",
    },
    {
      serviceId: "6",
      servicePK: "PK6",
      serviceName: "Finance Tracker 4",
      serviceDescription:
        "Track expenses and monitor financial growth.It helps you see how many more days you need to work to reach your financial goal for the month and the year.",
    },
    {
      serviceId: "7",
      servicePK: "PK7",
      serviceName: "Finance Tracker 5",
      serviceDescription:
        "Track expenses and monitor financial growth.It helps you see how many more days you need to work to reach your financial goal for the month and the year.",
    },
    {
      serviceId: "8",
      servicePK: "PK8",
      serviceName: "Finance Tracker 6",
      serviceDescription:
        "Track expenses and monitor financial growth.It helps you see how many more days you need to work to reach your financial goal for the month and the year.",
    },
    {
      serviceId: "9",
      servicePK: "PK9",
      serviceName: "Finance Tracker 7",
      serviceDescription:
        "Track expenses and monitor financial growth.It helps you see how many more days you need to work to reach your financial goal for the month and the year.",
    },
  ];*/

 /* const otherServicePlans = [
    {
      serviceId: "10",
      servicePK: "PK10",
      serviceName: "Health Assistant 1",
      serviceDescription:
        "AI-powered personal health monitoring service.It helps you see how many more days you need to work to reach your financial goal for the month and the year.",
    },
    {
      serviceId: "11",
      servicePK: "PK11",
      serviceName: "Customer Engagement 1",
      serviceDescription:
        "Tools for engaging customers efficiently.It helps you see how many more days you need to work to reach your financial goal for the month and the year.",
    },
    {
      serviceId: "12",
      servicePK: "PK12",
      serviceName: "Customer Engagement 2",
      serviceDescription:
        "Tools for engaging customers efficiently.It helps you see how many more days you need to work to reach your financial goal for the month and the year.",
    },
    {
      serviceId: "13",
      servicePK: "PK13",
      serviceName: "Customer Engagement 3",
      serviceDescription:
        "Tools for engaging customers efficiently.It helps you see how many more days you need to work to reach your financial goal for the month and the year.",
    },
    {
      serviceId: "14",
      servicePK: "PK14",
      serviceName: "Health Assistant 2",
      serviceDescription:
        "AI-powered personal health monitoring service.It helps you see how many more days you need to work to reach your financial goal for the month and the year.",
    },
    {
      serviceId: "15",
      servicePK: "PK15",
      serviceName: "Customer Engagement 4",
      serviceDescription:
        "Tools for engaging customers efficiently.It helps you see how many more days you need to work to reach your financial goal for the month and the year.",
    },
    {
      serviceId: "16",
      servicePK: "PK16",
      serviceName: "Health Assistant 3",
      serviceDescription:
        "AI-powered personal health monitoring service.It helps you see how many more days you need to work to reach your financial goal for the month and the year.",
    },
    {
      serviceId: "17",
      servicePK: "PK17",
      serviceName: "Customer Engagement 5",
      serviceDescription:
        "Tools for engaging customers efficiently.It helps you see how many more days you need to work to reach your financial goal for the month and the year.",
    },
  ];*/

  const activeServicePlansCount = servicePlans.length;
  const otherServicePlansCount = otherServicePlans.length;

  const indexOfLastActive = activePage * itemsPerPage;
  const indexOfFirstActive = indexOfLastActive - itemsPerPage;
  const currentActivePlans = servicePlans.slice(
    indexOfFirstActive,
    indexOfLastActive
  );

  const indexOfLastOther = otherPage * itemsPerPage;
  const indexOfFirstOther = indexOfLastOther - itemsPerPage;
  const currentOtherPlans = otherServicePlans.slice(
    indexOfFirstOther,
    indexOfLastOther
  );

  const paginateActive = (pageNumber) => setActivePage(pageNumber);
  const paginateOther = (pageNumber) => setOtherPage(pageNumber);

  const renderPagination = (
    totalItems,
    itemsPerPage,
    currentPage,
    paginate
  ) => {
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
      pageNumbers.push(i);
    }

    if (pageNumbers.length <= 1) {
      return null; // Don't show pagination if only one page or no items
    }

    const visiblePages = 5; // Number of visible page numbers in the pagination
    let startPage, endPage;

    if (pageNumbers.length <= visiblePages) {
      startPage = 1;
      endPage = pageNumbers.length;
    } else {
      if (currentPage <= Math.ceil(visiblePages / 2)) {
        startPage = 1;
        endPage = visiblePages;
      } else if (
        currentPage + Math.floor(visiblePages / 2) >=
        pageNumbers.length
      ) {
        startPage = pageNumbers.length - visiblePages + 1;
        endPage = pageNumbers.length;
      } else {
        startPage = currentPage - Math.floor(visiblePages / 2);
        endPage = currentPage + Math.floor(visiblePages / 2);
      }
    }

    return (
      <nav>
        <ul className="paginations justify-content-center">
          <li className={`pages-items ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              className="pages-links"
              onClick={() => paginate(Math.max(1, currentPage - 1))}
            >
              &lt;
            </button>
          </li>
          {startPage > 1 && (
            <li className="pages-items disabled">
              <span className="pages-links">...</span>
            </li>
          )}
          {pageNumbers.slice(startPage - 1, endPage).map((number) => (
            <li
              key={number}
              className={`pages-items ${
                currentPage === number ? "active" : ""
              }`}
            >
              <button onClick={() => paginate(number)} className="pages-links">
                {number}
              </button>
            </li>
          ))}
          {endPage < pageNumbers.length && (
            <li className="pages-items disabled">
              <span className="pages-links">...</span>
            </li>
          )}
          <li
            className={`pages-items ${
              currentPage === pageNumbers.length ? "disabled" : ""
            }`}
          >
            <button
              className="pages-links"
              onClick={() =>
                paginate(Math.min(pageNumbers.length, currentPage + 1))
              }
            >
              &gt;
            </button>
          </li>
        </ul>
      </nav>
    );
  };

  // ❌ Commented out dynamic data fetching logic for now

  useEffect(() => {
    const fetchHomePageDetails = async () => {
      try {
        const responseData = await homePageService.homePageDetails(`${language}`);
        const formattedData = responseData.map((service) => ({
          serviceId: service.serviceId,
          serviceName: service.serviceInfo.SERVICE_NAME,
          serviceDescription: service.serviceInfo.SERVICE_DESCRIPTION
        }));
        setServicePlans(formattedData);
      } catch (error) {
        console.error("Error fetching service plans:", error);
      }
    };
    fetchHomePageDetails();
  }, [language]);
 // added//
 useEffect(() => {
  const fetchHomePageOtherServiceDetails = async () => {
    try {
      const responseData = await homePageService.homePageOtherServiceDetails(`${language}`);
      const formattedData = responseData.map((service) => ({
        serviceId: service.serviceId,
        serviceName: service.serviceInfo.SERVICE_NAME,
        serviceDescription: service.serviceInfo.SERVICE_DESCRIPTION,
        serviceIsNew:service.new
      }));
      setOtherServicePlans(formattedData);
    } catch (error) {
      console.error("Error fetching service plans for other services:", error);
    }
  };
  fetchHomePageOtherServiceDetails();
}, [language]);

 //added//

 // Helper function to get the current tab label
 const getCurrentTabLabel = () => {
  if (activeTab === "tab1") {
    return t("active_services");
  } else if (activeTab === "tab2") {
    return t("other_services");
  }
  return ""; // Default case
};

// Helper function to get the total count based on the active tab
const getTotalCount = () => {
  if (activeTab === "tab1") {
    return activeServicePlansCount;
  } else if (activeTab === "tab2") {
    return otherServicePlansCount;
  }
  return 0; // Default case
};

  // Determine the description based on the active tab
  const getDescription = () => {
    if (activeTab === "tab1") {
      return t("total_active_service_plans", {  
        count: activeServicePlansCount,
      });
    } else if (activeTab === "tab2") {
      return t("total_other_service_plans", {
        count: otherServicePlansCount,
      });
    }
    return ""; // Default case
  };

  return (
    <main className="container-fluid" style={{ padding: "8px" }}>
      <div
        className="row p-1 rounded"
        style={{ backgroundColor: "rgb(244 244 244)" }}
      >
        {/* ✅ Mobile View Tabs */}
        <div className="col-8 d-md-none">
          <TabComponent
            title={t("all_in_one_service_plans")}
            tabs={[
              { key: "tab1", label: t("active_services") },
              { key: "tab2", label: t("other_services") },
            ]}
            onTabChange={(tabKey) => setActiveTab(tabKey)}
          />
        </div>

        {/* ✅ Mobile View */}
        {activeTab === "tab1" && (
          <>
            <div className="col-12 order-2 d-md-none">
              <Balance />
            </div>

            <div className="col-11 order-3 d-md-none mx-auto text-center">
              <ServicePlans servicePlans={currentActivePlans} />
              {activeServicePlansCount > itemsPerPage &&
                renderPagination(
                  activeServicePlansCount,
                  itemsPerPage,
                  activePage,
                  paginateActive
                )}
            </div>

            <div className="col-11 order-4 d-md-none mx-auto">
              <Transactions />
            </div>

            <div className="col-11 order-5 d-md-none mx-auto">
              <Advertisement />
            </div>
          </>
        )}

        {/* Mobile View - Other Services */}
        {activeTab === "tab2" && (
          <>
            <div className="col-12 order-2 d-md-none">
              <Balance />
            </div>

            <div className="col-11 order-3 d-md-none mx-auto text-center">
              <OtherServicePlans servicePlans={currentOtherPlans} />
              {otherServicePlansCount > itemsPerPage &&
                renderPagination(
                  otherServicePlansCount,
                  itemsPerPage,
                  otherPage,
                  paginateOther
                )}
            </div>

            <div className="col-11 order-4 d-md-none mx-auto">
              <Transactions />
            </div>

            <div className="col-11 order-5 d-md-none mx-auto">
              <Advertisement />
            </div>
          </>
        )}

        {/* ✅ Desktop View Tabs (Moved into col-md-8) */}
        <div className="col-md-8 order-md-1 d-none d-md-block p-4">
        <TabComponent
            title={t("all_in_one_service_plans")}
            description={getDescription()} // Dynamically set the description
            tabs={[
              {
                key: "tab1",
                label: t("active_services"),
              },
              {
                key: "tab2",
                label: t("other_services"),
              },
            ]}
            onTabChange={(tabKey) => setActiveTab(tabKey)}
          />


          {activeTab === "tab1" && (
            <>
              <div className="row g-4">
                {activeServicePlansCount > 3
                  ? currentActivePlans.map((service) => (
                      <div key={service.serviceId} className="col-md-6 g-4">
                        <ServicePlans servicePlans={[service]} />
                      </div>
                    ))
                  : currentActivePlans.map((service) => (
                      <div key={service.serviceId} className="col-md-12">
                        <ServicePlans servicePlans={[service]} />
                      </div>
                    ))}
              </div>

              <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="text-muted small">
                  {t("showing_data")} {indexOfFirstActive + 1} {t("to")}{" "}
                  {Math.min(indexOfLastActive, activeServicePlansCount)}{" "}
                  {t("entries")}
                </div>
              </div>
              
              {/* 📌 Ensure pagination stays fixed at the bottom */}
              <div className="paginations-container">
                {activeServicePlansCount > itemsPerPage &&
                  renderPagination(
                    activeServicePlansCount,
                    itemsPerPage,
                    activePage,
                    paginateActive
                  )}
              </div>
            </>
          )}

          {activeTab === "tab2" && (
            <>
              <div className="row g-4">
                {otherServicePlansCount > 3
                  ? currentOtherPlans.map((service) => (
                      <div key={service.serviceId} className="col-md-6 g-4">
                        <OtherServicePlans servicePlans={[service]} />
                      </div>
                    ))
                  : currentOtherPlans.map((service) => (
                      <div key={service.serviceId} className="col-md-12">
                        <OtherServicePlans servicePlans={[service]} />
                      </div>
                    ))}
              </div>

                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div className="text-muted small">
                    {t("showing_data")} {indexOfFirstOther + 1} {t("to")}{" "}
                    {Math.min(indexOfLastOther, otherServicePlansCount)}{" "}
                    {t("entries")}
                  </div>
                </div>

                <div className="paginations-container">
                {otherServicePlansCount > itemsPerPage &&
                  renderPagination(
                    otherServicePlansCount,
                    itemsPerPage,
                    otherPage,
                    paginateOther
                  )}
                  </div>
              </>
            )}
          </div>

        {/* ✅ Sidebar remains visible for both tabs */}
        <div className="col-md-4 order-md-2 d-none d-md-block p-4">
          <Balance />
          <Transactions />
          <Advertisement />
        </div>
      </div>
    </main>
  );
};

export default Main;
